/**
 * `core/momentumScroll/momentumScroll.js`
 *  - 慣性スクロール（Lenis / GSAP ScrollSmoother）の切り替え
 *
 * 使用方法:
 *  - import { initMomentumScroll, resetMomentumScroll } from "../core/momentumScroll/momentumScroll.js";
 */


import {config} from "../../config.js";
import {isMobile} from "../../utils/index.js";


/**
 * 慣性スクロールの初期化
 * @param {Object} data - Barba.jsの遷移データ（任意）
 */
export const initMomentumScroll = async (data = null) => {
  console.log("🌀 Initializing Momentum Scroll...");

  // スマホではデフォルトスクロールを使用
  if (isMobile()) {
    console.log("📱 Mobile detected. Default scrolling enabled.");
    return;
  }

  try {
    switch (config.momentumScrolling) {
      case "gsap": {
        const {initGsapScrollSmoother} = await import(
          /* webpackChunkName: "GsapScrollSmoother" */ "./gsapScrollSmoother/gsapScrollSmoother.js"
          );
        await initGsapScrollSmoother(data);
        break;
      }

      case "lenis": {
        const {initLenis} = await import(
          /* webpackChunkName: "lenis" */ "./lenis/lenis.js"
          );
        await initLenis();
        break;
      }

      default: {
        console.log("🚀 Default browser scroll is used.");
        break;
      }
    }
  } catch (error) {
    console.error("⚠️ Error initializing momentum scroll:", error);
  }
};


/**
 * 慣性スクロールのリセット（Barba.jsのページ遷移時に使用）
 */
export const resetMomentumScroll = async () => {
  try {
    if (config.momentumScrolling === "gsap") {
      const {resetGsapScrollSmoother} = await import(
        /* webpackChunkName: "GsapScrollSmoother" */ "./gsapScrollSmoother/gsapScrollSmoother.js"
        );
      await resetGsapScrollSmoother();
    } else if (config.momentumScrolling === "lenis") {
      const {resetLenis} = await import(
        /* webpackChunkName: "lenis" */ "./lenis/lenis.js"
        );
      await resetLenis();
    }
  } catch (error) {
    console.error("⚠️ Error resetting momentum scroll:", error);
  }
};